// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "069b4b58063f";
export const BUILD_VERSION_NUMBER = 15;
